export enum CertPeriodRecapQuestionnaireItem {
  CERT_PERIOD_RECAP = 'cert-period-recap',
  CERT_PERIOD_RECAP_CONSENT = 'cert-period-recap/consent',
  CERT_PERIOD_RECAP_CARE_STATUS = 'cert-period-recap/care-status',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_ER = 'cert-period-recap/care_status/60-day-er',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_ER_NOTES = 'cert-period-recap/care_status/60-day-er-notes',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_HOSPITAL = 'cert-period-recap/care_status/60-day-hospital',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_HOSPITAL_NOTES = 'cert-period-recap/care_status/60-day-hospital-notes',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_INJURIES = 'cert-period-recap/care_status/60-day-injuries',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_INJURIES_NOTES = 'cert-period-recap/care_status/60-day-injuries-notes',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_FALLS = 'cert-period-recap/care_status/60-day-falls',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_FALLS_NOTES = 'cert-period-recap/care_status/60-day-falls-notes',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_INFECTIONS = 'cert-period-recap/care_status/60-day-infections',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_INFECTIONS_NOTES = 'cert-period-recap/care_status/60-day-infections-notes',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_MD = 'cert-period-recap/care_status/60-day-md',
  CERT_PERIOD_RECAP_CARE_STATUS_60_DAY_MD_NOTES = 'cert-period-recap/care_status/60-day-md-notes',
  CERT_PERIOD_RECAP_NOTES = 'cert-period-recap/notes',
  CERT_PERIOD_RECAP_NOTES_NOTE = 'cert-period-recap/notes/note',
  CERT_PERIOD_RECAP_GOALS = 'cert-period-recap/goals',
  CERT_PERIOD_RECAP_GOALS_GOAL_ID = 'cert-period-recap/goals/goal-id',
  CERT_PERIOD_RECAP_GOALS_GOAL_STATUS = 'cert-period-recap/goals/goal-status',
  CERT_PERIOD_RECAP_INITIALS_AUTHORIZATION = 'cert-period-recap/initials-authorization'
}
